import React, { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";

import { GetCircle } from "../../../Apis/organizationApi";

import AssetStatusSummary from "./AssetStatusSummary";

import AttendanceSummary from "./AttendanceSummary";

import ShiftWiseSummary from "./ShiftWiseSummary";

import WasteCollectionSummary from "./WasteCollectionSummary";

import DeploymentSummary from "./DeploymentSummary";

import ComplaintSummaryPanel from "./ComplaintSummaryPanel";

import IeComplaintSummary from "./IeComplaintSummary";

import DrainSiltComplaintSummary from "./DrainSiltComplaintSummary";

import "./PrimaryDashboard.css";



const Dashboard = () => {

  const [wards, setWards] = useState([]);



  useEffect(() => {

    const fetchWards = async () => {

      try {

        const response = await GetCircle();

        const list = Array.isArray(response)

          ? response

          : Array.isArray(response?.data)

            ? response.data

            : [];

        setWards(list.filter((item) => item.isActive !== false));

      } catch (error) {

        console.error("Failed to load wards:", error);

        setWards([]);

      }

    };



    fetchWards();

  }, []);



  return (

    <div className="pd-page">

      <div className="content">

        <div className="page-content">

          <div className="pd-topbar">

            <h5>Dashboard</h5>

          </div>



          <AssetStatusSummary />



          <Row className="g-3 mb-0 pd-attendance-shift-row">

            <Col xl={4} lg={12}>

              <AttendanceSummary wards={wards} />

            </Col>

            <Col xl={8} lg={12}>

              <ShiftWiseSummary wards={wards} />

            </Col>

          </Row>



          <Row className="g-3 mb-0 pd-waste-deployment-row">

            <Col xl={7} lg={12}>

              <WasteCollectionSummary wards={wards} />

            </Col>

            <Col xl={5} lg={12}>

              <DeploymentSummary wards={wards} />

            </Col>

          </Row>



          <ComplaintSummaryPanel wards={wards} />



          <Row className="g-3 mb-0 pd-complaint-row">

            <Col lg={6}>

              <IeComplaintSummary wards={wards} />

            </Col>

            <Col lg={6}>

              <DrainSiltComplaintSummary wards={wards} />

            </Col>

          </Row>

        </div>

      </div>

    </div>

  );

};



export default Dashboard;


